export default "| **N-12** | Decided Oct 21 (the 1A program): an Event is a session with more than one step | #1374 | Nov 1 |"